import React from 'react'
import Nav from './Nav'

const About = () => {
  return (
    <>
      <main id="main" class="bg-img">
        <div id="bgImg">
          <div class="container">

            <Nav />


            <div class="content">
              <span>ABOUT US</span>
              <h1>ABOUT US</h1>
              <p>Welcome to PERFECT, where innovation meets <br/> excellence in digital solutions! With over 5 years of experience,<br/> we specialize in a comprehensive suite of services designed<br/> to elevate your online presence and drive business growth.</p>
              <a href="services.html" data-target="#carouselExampleCaptions" data-slide-to="2">OUR SERVICES</a>
            </div>

            <div class="social-media" style={{ marginTop: "40px" }}>
              <a href="https://www.facebook.com/Perfect-151150445074122"><img src="img/facebook.png" /></a>
              <a href="https://www.instagram.com/perfect94446783/?fbclid=IwAR14fVz3P2rQ5x8Y8sAlERhd1ldCJhGDPt8M1KAoDsH3sO-y_vDRKNy4Yqg"><img src="img/instagram.png" /></a>
              <a href="https://www.youtube.com/channel/UC-RBwShQdGVl8aQCo2tyHnA/featured"><img src="img/youtube.png" /></a>

              <span>SOCIAL MEDIA</span>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}

export default About
